import cx from 'classnames'

import { Attribute } from '../../components/attribute/Attribute'
import { BlockIndicator } from '../../components/blockIndicator/BlockIndicator'
import { DraftIndicator } from '../../components/draftIndicator/DraftIndicator'
import { LayerIndicator } from '../../components/layerIndicator/LayerIndicator'
import type { EnumDefinition } from '../../uiModels/enumLiterals/types'

type Props = {
  data: EnumDefinition
}

export const EnumNameCell = ({ data }: Props) => (
  <div className="flex size-full items-center justify-start gap-x-4">
    <h4
      className={cx('m-0 pl-2 font-medium', {
        'line-through': !!data.internalOperation?.entity?.deprecated,
      })}
    >
      {data.name}
    </h4>
    {data.isDraft && <DraftIndicator size="small" />}
    {data.block && data.internalOperation ? (
      <BlockIndicator
        block={data.block}
        shouldShowIcon={false}
        isSecondaryBackground={false}
      />
    ) : (
      <Attribute>?</Attribute>
    )}
    {data.layer && data.internalOperation ? (
      <LayerIndicator layer={data.layer} isSecondaryBackground={false} />
    ) : (
      <Attribute>?</Attribute>
    )}
  </div>
)
